export const columns = [
    {
        key: 'cod_agente',
        label: 'Codigo de Agente'

    },
    {
        key: 'NUM_SUBRECLAMO',
        label: 'Nro Subreclamo'

    },
    {
        key: 'cod_tomador',
        label: 'Codigo de Tomador'
    },
    {
        key: 'ramo',
        label: 'Ramo',
        sortable: true,
        checked: true
    },
    {
        key: 'nro_siniestro',
        label: 'Nro. Stro.',
        sortable: true,
        checked: true
    },
    {
        key: 'tomador',
        label: 'Tomador',
        sortable: true,
        checked: true
    },
    {
        key: 'asegurado',
        label: 'Asegurado',
        sortable: true,
        checked: true
    },
    {
        key: 'FECHA_RECLAMO',
        label: 'Fecha de Reclamo'
    },
    {
        key: 'ORIGEN_INCIDENCIA_I',
        label: 'Origen Incidencia'
    },
    {
        key: 'TIPO_DE_DANO_I',
        label: 'Tipo de Daño'
    },
    {
        key: 'estado',
        label: 'Estado',
        sortable: true,
        checked: true
    }
];